/*
 * WARNING! Endring i values vil (i noen tilfeller) endre navn på variabel som legges inn i redux store.
 * */
export default {
    EPOSTADRESSE: 'epost',
    TELEFONNUMMER: 'mobiltelefon',
    SIVILSTATUS: 'sivilstatus',
    BOFORHOLD: 'boforhold',
    ARBEIDSFORHOLD: 'arbeidsforhold',
    SIKRET_GJELD: 'annensikretgjeld',
    FOEDELAND: 'fodeland',
    STATSBORGERSKAP: 'statsborgerskap',
    SEKUNDAERT_STATSBORGERSKAP: 'sekundaertStatsborgerskap',
    POLITISK_EKSPONERT_PERSON: 'pep',
    RELASJON: 'relasjon',
    VERV: 'verv',
    KREDITTBELOP: 'kredittbelop',
    FORFALLSDATO: 'forfallsdato',
    CUSTOM_PIN_KODE: 'custompinkode',
    PIN_KODE: 'pinkode',
    PIN_KODE_CONFIRM: 'pinkodeconfirm',
    ANDREKORT: 'harAndreKort',
    CREDITAMOUNT: 'requestedCreditAmount',
};
